import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import _ from "lodash";
import * as gameAction from "../../redux/game/action";
import * as loaderAction from "../../redux/loader/action";
import * as paramsAction from "../../redux/gameParams/actions";
import Socket from "socket";
import { get_route_from_game_code } from "shared/helpers/get_route_from_game_code";

import useWindowDimensions from "shared/helpers/getWindowDimensions";

const SessionLobby = (props) => {
  const sessionObj = _.get(props, "gameReducer.sessionObj");
  const { height } = useWindowDimensions();

  useEffect(() => {
    sessionObj?.session_id === undefined && props.history.replace("/");
  }, [sessionObj]);

  useEffect(() => {
    return Socket.addListener("others", handle_others, (err) => {
      console.log("errerr: ", err);
    });
  }, []);

  const handle_others = (res) => {
    if (res && res.room) {
      on_get_room(res);
    }
  };

  const on_get_room = async (res) => {
    if (res && res.room) {
      const game_code = res.room.game_code;
      const branch_url = res.room.branch_url;
      if (get_route_from_game_code(game_code) === "slice") {
        props.setIsLoading(false);
        props.endGame();
        props.setSliceGameCode(branch_url);
      } else {
        props.setGameName(game_code);
        // if (game_code === "SBS") {
        //   await props.getSubGameData({ gameName: game_code });
        // } else {
        //   await props.getGameData({ gameName: game_code });
        // }
        await props.getGameData({ gameName: game_code });
        const route = get_route_from_game_code(game_code);
        props.setIsLoading(false);
        props.history.replace(route);
      }
    } else {
      props.setIsLoading(false);
    }
  };

  const listStyles = {
    width: "100%",
    overflowY: "auto",
    marginTop: "25px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    padding: "0 38px 25px"
  };

  return (
    <div className="session-lobby">
      <h2 className="heading">Waiting for the host to choose an activity</h2>
      <div style={{ ...listStyles, maxHeight: `${height - 190}px` }}>
        {!_.isEmpty(sessionObj?.users) &&
          sessionObj.users.map((user, index) => (
            <div key={index} className="user-container">
              <div className="host-parent">
                <img
                  key={index}
                  alt=""
                  src={user.profile_image}
                  className="user-avatar"
                />
                {sessionObj.host_user_id === user.user_id && (
                  <div className="host-div">
                    <span className="host-text">Host</span>
                  </div>
                )}
              </div>
              <span className="user-name">{user.display_name}</span>
            </div>
          ))}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    endGame: (data) => dispatch(gameAction.endGame(data)),
    setSliceGameCode: (data) => dispatch(gameAction.setSliceGameCode(data)),
    setGameName: (data) => dispatch(gameAction.setGameName(data)),
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    getGameData: (data) => dispatch(paramsAction.getGameData(data)),
    getSubGameData: (data) => dispatch(paramsAction.getSubGameData(data))
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(SessionLobby);
